// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"946ffc00","179":"c3977432","207":"d3533370","330":"fd09e492","594":"5e1d871f"}[chunkId] + ".js";
};